import api from './client';

export interface BackInStockSettings {
  enabled: boolean;
  button_text: string;
  success_message: string;
  button_color: string;
}

export interface BackInStockSubscription {
  id: number;
  product_title: string;
  variant_title: string | null;
  email: string;
  notified_at: string | null;
  created_at: string | null;
}

export const backInStockApi = {
  show: () =>
    api.get<{ data: { settings: BackInStockSettings; pending_count: number } }>('/back-in-stock'),

  update: (settings: BackInStockSettings) =>
    api.put<{ data: BackInStockSettings }>('/back-in-stock', settings),

  subscriptions: (page = 1) =>
    api.get<{ data: BackInStockSubscription[]; meta: { total: number; current_page: number; last_page: number } }>(
      `/back-in-stock/subscriptions?page=${page}`
    ),
};
